/**
 * Collapse a market-keyed lender key to its protocol family:
 * `MORPHO_BLUE_<id>` / `AAVE_V4_<spoke>` / `SILO_V2_<silo>` -> `MORPHO_BLUE`,
 * `AAVE_V4`, `SILO_V2`.
 *
 * Used wherever INDEPENDENT sources are counted. One protocol emitting a
 * price per market must not look like agreement between many protocols —
 * that is the difference between "four oracles agree" and "one oracle, read
 * four times".
 *
 * Suffixes that are not pure hex (`COMPOUND_V3_USDC`, `AAVE_V3_ETHER_FI`)
 * are distinct deployments and keep their key.
 *
 * Lives in its own module so `feedStats` and `selectAssetGroupPrices` can
 * both use it without an import cycle.
 */
export function lenderFamily(lender: string): string {
  return lender.replace(/_(0X)?[0-9A-F]{6,}$/i, '')
}
